import React from 'react';

export const CheckCircleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_86_1160)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8Z"
        fill="#EFEDFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4247 5.57576C11.659 5.81008 11.659 6.18997 11.4247 6.42429L7.42466 10.4243C7.19034 10.6586 6.81044 10.6586 6.57613 10.4243L4.57613 8.42429C4.34181 8.18997 4.34181 7.81008 4.57613 7.57576C4.81044 7.34145 5.19034 7.34145 5.42465 7.57576L7.00039 9.1515L10.5761 5.57576C10.8104 5.34145 11.1903 5.34145 11.4247 5.57576Z"
        fill="#EFEDFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_86_1160">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/CheckCircle.icon.jsx